<template>
  <div class="d-flex">
    <!-- SinalDeposit Option (exato, maior, menor) -->
    <v-select
      v-model="selectSinalDeposit"
      :items="items"
      :label="$t('byDeposit')"
      @change="setSinalDeposit"
      prepend-icon="mdi-wallet"
      item-text="text"
      item-value="option"
      dense
      filled
      hide-details
      solo-inverted
    ></v-select>
    <!-- Sinal Valor -->
    <v-text-field
      v-model="valorDeposit"
      class="ml-2"
      label="Outlined"
      :placeholder="$t('qtyDeposits')"
      solo-inverted
      dense
      hide-details
      @change="setSinalDeposit"
      type="number"
    ></v-text-field>
  </div>
</template>
<script>
export default {
  name: "components-common-filters-sinalDeposit",
  data: () => ({
    selectSinalDeposit: null,
    valorDeposit: null,
  }),
  computed: {
    items() {
      return [
        { text: this.$t("exactQty"), option: "exatamente" },
        { text: this.$t("QtyGreaterThan"), option: "maior" },
        { text: this.$t("QtyLessThan"), option: "menor" },
      ];
    },
  },
  mounted() {
    // Recupera o último valorDeposit informado pelo o usuário
    // e deixa o selectSinalDeposit selecionado com o mesmo.
    var option = this.$store.state.filters.sinalDeposit.option;
    var selectSinalDeposit = this.items.filter(
      (element) => element.option == option
    );
    this.selectSinalDeposit = selectSinalDeposit[0];
  },
  methods: {
    setSinalDeposit() {
      var option = this.selectSinalDeposit;
      var valor = this.valorDeposit;
      // Só enviar para o vuex se os dois estiverem preenchidos:
      if (option != null && valor != null) {
        this.$store.commit("setSinalDeposit", { option, valor });
      }
    },
  },
};
</script>
